module.exports = __webpack_public_path__ + "assets/img/module-list-arrow.svg";